import { color } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/postcss/lib/postcss.js";
import "../../node_modules/postcss-js/index.js";
import "../../node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
import { iconBaseLarge, iconBase, base, baseLarge } from "./_base.js";
const classNamePrefix = "umd-action-outline";
const outlineBase = {
  backgroundColor: color.white,
  border: `1px solid ${color.gray.darker}`,
  color: color.black,
  transition: "background 0.5s ease-in-out, border 0.5s ease-in-out, color 0.5s ease-in-out",
  [`&:hover, &:focus`]: {
    backgroundColor: color.gray.darker,
    color: color.white,
    "& svg": {
      fill: color.white
    }
  }
};
function composeOutline(options) {
  const { size = "normal", color: buttonColor = "default" } = options || {};
  let composed = {};
  if (size === "normal") {
    composed = {
      ...base
    };
  } else if (size === "large") {
    composed = {
      ...baseLarge
    };
  }
  if (buttonColor === "default") {
    composed = {
      ...composed,
      ...outlineBase,
      "& svg": size === "large" ? {
        ...iconBaseLarge,
        fill: color.red,
        "& path": { fill: color.red }
      } : {
        ...iconBase,
        fill: color.red,
        "& path": { fill: color.red }
      }
    };
  } else if (buttonColor === "white") {
    composed = {
      ...composed,
      color: color.white,
      border: `1px solid ${color.white}`,
      transition: "background 0.5s ease-in-out, border 0.5s ease-in-out, color 0.5s ease-in-out",
      [`&:hover, &:focus`]: {
        border: `1px solid ${color.white}`,
        backgroundColor: color.white,
        color: color.black,
        "& svg": {
          fill: color.black
        }
      },
      "& svg": size === "large" ? { ...iconBaseLarge, fill: color.white } : { ...iconBase, fill: color.white }
    };
  }
  let className = `${classNamePrefix}`;
  const deprecatedAliases = [];
  if (size === "large" && buttonColor === "default") {
    className = `${classNamePrefix}-large`;
  } else if (size === "normal" && buttonColor === "white") {
    className = `${classNamePrefix}-white`;
  } else if (size === "large" && buttonColor === "white") {
    className = `${classNamePrefix}-large-white`;
  } else if (size === "normal" && buttonColor === "default") {
    deprecatedAliases.push("umd-forms-actions-outline");
  }
  return objectWithClassName({
    ...composed,
    className: deprecatedAliases.length > 0 ? [className, ...deprecatedAliases] : className
  });
}
const normal = composeOutline();
const large = composeOutline({ size: "large" });
const white = composeOutline({ color: "white" });
export {
  composeOutline,
  large,
  normal,
  white
};
//# sourceMappingURL=outline.js.map
